import React, { useEffect, useState } from "react";
import {
  Box, Heading, VStack
} from "@chakra-ui/react";
import { Session } from "types/session";
import { add, sub } from "date-fns";
import { queryKeys, queryFns } from "repo/sessions";
import { useQuery } from "@tanstack/react-query";
import { SessionCard } from "components";
import {
  filterActiveSessions,
  filterFutureSessions,
  filterUpcomingSessions
} from "utils/session";
import { useUser } from "context/user";
import { UserRole } from "types/user";
import { truncate } from "utils/date";

const UpcomingSessions: React.FC = () => {
  const { user } = useUser()!;


  const dt = truncate(new Date())

  const filter: any = {
    id: 'start_time_range',
    value: JSON.stringify([sub(dt, { minutes: 75 }), add(dt, { days: 2 })])
  };
  const queryProps = {
    defaultFilters: [filter],
    pageIndex: 0,
    pageSize: 10,
    order: ["start_time", "ASC"]
  };

  const { data, isLoading, error } = useQuery({
    queryKey: ['sessions', true, queryProps],
    queryFn: queryFns.data
  });

  const getSeq = (sessions: Session[] | undefined) => {
    if (sessions) {
      const activeSessions = filterActiveSessions(sessions);
      const upcomingSessions = filterUpcomingSessions(sessions);
      const futureSessions = filterFutureSessions(sessions);

      const prioritySessions = user.privs == UserRole.Client ?
        activeSessions :
        upcomingSessions
      if (prioritySessions.length > 0) return prioritySessions;
      else return futureSessions;
    }
    else return [];
  }

  const sessionsVisible = user.privs >= UserRole.Coach ? 1 : 2

  return (
    <Box>
      <Heading size="lg" mb={8}>
        Upcoming Coaching Calls
      </Heading>
      <VStack spacing={8} alignItems="flex-start">
        {!isLoading && !error && getSeq(data?.entries).sort((x, y) => new Date(x.start_time).getTime() - new Date(y.start_time).getTime()).slice(0, sessionsVisible).map(session => (
          <SessionCard session={session} key={session.id} />
        ))}
      </VStack>
    </Box>
  );
}

export default UpcomingSessions;
